type TransportItem = { transportType?: string; computed?: unknown };

/** Value saved by a CarbonFootprintTransportField: one item per trip */
export type CarbonFootprintTransportValue = {
  items?: TransportItem[];
};

/** Trips of a value, or undefined when malformed: these rules also check client input server-side */
function getItems(transport: CarbonFootprintTransportValue | undefined): TransportItem[] | undefined {
  const items = transport?.items;
  return Array.isArray(items) ? items : undefined;
}

function isValidTransport(item: TransportItem | null | undefined): boolean {
  if (!item || typeof item !== 'object') return false;
  const { transportType, computed } = item;
  if (!transportType) return false;
  return transportType === 'none' || transportType === 'carpooling' || !!computed;
}

/** Every trip has a transport type, and its footprint is computed when it needs one */
export function hasRequiredTransportData(transport: CarbonFootprintTransportValue | undefined): boolean {
  const items = getItems(transport);
  if (!items?.length) return false;

  return items.every((item) => isValidTransport(item));
}

/**
 * A trip is started as soon as one of its transport types is chosen
 */
export function hasStartedTransport(transport: CarbonFootprintTransportValue | undefined): boolean {
  return !!getItems(transport)?.some((item) => !!item?.transportType);
}

/**
 * Optional only when explicitly unchecked in the editor: a missing `required` keeps it mandatory.
 * Once a trip is started, it must be completed.
 */
export function isTransportRequired(required: boolean | undefined, transport: CarbonFootprintTransportValue | undefined): boolean {
  return required !== false || hasStartedTransport(transport);
}
